import React from 'react';

import { Grid, Cell } from '@carvana/showroom-grid';
import { useSearchState } from '../../../context';

import {
  StyledContainer,
  StyledButton,
  StyledIconRightCaret,
  StyledIconLeftCaret
} from './styles';

import PagesSelect from './pages-select';
import PagesList from './pages-list';

const Pagination = () => {
  const { page, pagesTotal, onPageChange } = useSearchState();

  const handlePageChange = (number) => () => {
    onPageChange(number);
  };

  return (
    <StyledContainer>
      <Grid alignItems="center" justifyContent="space-between">
        <Cell>
          <StyledButton disabled={page === 1} onClick={handlePageChange(page - 1)}>
            <StyledIconLeftCaret />
          </StyledButton>
        </Cell>
        <Cell>
          <Grid paddingBottom={0}>
            <PagesList />
            <PagesSelect />
          </Grid>
        </Cell>
        <Cell>
          <StyledButton disabled={page === pagesTotal} onClick={handlePageChange(page + 1)}>
            <StyledIconRightCaret />
          </StyledButton>
        </Cell>
      </Grid>
    </StyledContainer>
  );
};

export default Pagination;
